import * as React from 'react'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle, MarketingSection } from '../styles/marketing.styles'

export const ContactPage: React.FC = () => {
  const [name, setName] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [message, setMessage] = React.useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    window.location.href = `mailto:support@equa.cc?subject=Contact from website&body=${encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\n${message}`)}`
  }

  return (
    <MarketingLayout>
      <MarketingPageContainer>
        <MarketingSection>
          <PageTitle>Contact</PageTitle>
          <PageSubtitle>Get in touch with our team.</PageSubtitle>
        </MarketingSection>
        <MarketingSection>
          <p>Email: <a href="mailto:support@equa.cc" style={{ color: '#3292C0' }}>support@equa.cc</a></p>
          <form onSubmit={handleSubmit} style={{ maxWidth: 400, display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} style={{ padding: '0.5rem' }} required />
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} style={{ padding: '0.5rem' }} required />
            <textarea placeholder="Message" value={message} onChange={(e) => setMessage(e.target.value)} rows={4} style={{ padding: '0.5rem' }} required />
            <button type="submit" style={{ padding: '0.5rem 1rem', background: '#33AA40', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Send</button>
          </form>
        </MarketingSection>
      </MarketingPageContainer>
    </MarketingLayout>
  )
}
